import { createStore } from 'vuex'
import userInfo from './user/UserInfo'
import common from './common'


const state = {
  PagePathStatus: true,
  PageParentBackPath: () => {
  },
  PageChildBackPath: () => {
  },
  partner: {},
  backStatus: {
    registerBack: true
  }
};

export default createStore({
  state,
  modules: {
    userInfo,
    common,
  },
  plugins: [

    // createPersistedState(),

  ],
})
